/* eslint-disable @typescript-eslint/ban-types */
import { Cell } from 'react-table';

interface Props<D extends object> {
    cell: Cell<D>;
}

/**
 * Displays a date like: 5/12/2020
 * @param Props must contain a `cell.value` which is either a string or number that can be used to
 * instantiate a JavaScript Date. Usually this will be an AWSDateTime, which is an ISO8601 date
 * string.
 */
export function DateCell<D extends object>({
    cell,
}: Props<D>): JSX.Element | string {
    const { value } = cell;

    if (value === null) {
        return '';
    }

    const date = new Date(value);

    return new Intl.DateTimeFormat('en', { calendar: 'gregory' }).format(date);
}
